import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService } from 'app/client-core/services/analytics-service';

@Component({
  selector: 'app-analytics-link',
  templateUrl: './analytics-link.component.html',
  styleUrls: ['./analytics-link.component.css']
})
export class AnalyticsLinkComponent implements OnInit {
  @Input() title: string;
  @Input() classes: string;
  @Input() eventCategory: string;
  @Input() eventAction: string;
  @Output() linkClicked = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  click() {
    AnalyticsService.sendEvent(this.eventCategory, this.eventAction);
    this.linkClicked.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/analytics-link/analytics-link.component.ts